import { InjectionToken } from '@angular/core';
import { Wine, WinePayload, WineUploadUrlResponse } from '../models/wine';

export interface WinesApi {
  list(wineryId?: string): Promise<Wine[]>;
  create(payload: WinePayload, wineryId?: string): Promise<Wine>;
  update(id: string, payload: WinePayload, wineryId?: string): Promise<Wine>;
  getUploadUrl(
    fileName: string,
    contentType: string,
    wineryId?: string
  ): Promise<WineUploadUrlResponse>;
}

export const WINES_API = new InjectionToken<WinesApi>('WINES_API');
